import type { FunctionComponent } from 'react';

import type { SvgProps } from './types';

export const AbbCheckMark: FunctionComponent<SvgProps> = ({ fill = '#1f1f1f', size = 24, ...props }) => {
  return (
    <>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width={size} height={size} fill={fill} {...props}>
        <g id='Box'>
          <rect fill='none' width={size} height={size} />
        </g>
        <g id='Final_icons_-_Common' data-name='Final icons - Common'>
          <path d='M8.97 15.97 4 11l-2 2 7 7L21 8l-2-2-10.03 9.97z' />
        </g>
      </svg>
    </>
  );
};
